import React from 'react';
import Button from '../Button/button';
import { useGeneralHooks } from '../../Hooks/hooks';
import { ButtonTypes, IMainCard } from '../../Interfaces/componentTypes';
import MainCard from '../Cards/MainCards/mainCard';
import { Card1, Card2, Card3, Card4 } from '../../Assets/Images';
import styles from './mainContent.module.scss';
import MainFooter from '../Footers/MainFooter/mainFooter';
import ServiceSections from './Contents/ServiceSections/serviceSections';
import DesignCustomization from './Contents/DesignCustomization/designCustomization';

const MainContent: React.FC = () => {
  const { navigate, largeScreen, t } = useGeneralHooks();
  const mainCards: IMainCard[] = [
    {
        title: t('Main.Content_1.Card1'),
        image: Card1
    },
    {
        title: t('Main.Content_1.Card2'),
        image: Card2
    },
    {
        title: t('Main.Content_1.Card3'),
        image: Card3
    },
    {
        title: t('Main.Content_1.Card4'),
        image: Card4
    },
];

  return (
    <>
      {
        largeScreen
          ?
          <>
          <div className={styles.container}>
            <div className={styles.firstBox}>
              <div className={styles.contentHeaderBox}>
                <p className={styles.contentHeaderText}>
                  {t("Main.Content_1.Header")}
                </p>
              </div>
              <p className={styles.contentTitle}>
                {t("Main.Content_1.Title")}
              </p>
              <p className={styles.contentDescription}>
                {t("Main.Content_1.Text")}
              </p>
              <Button
                buttonType={ButtonTypes.Primery}
                title={t("Main.Demo_btn")}
                buttonStyle={styles.button}
                onClick={() => navigate('/signUp')}
              />
            </div>
            <div className={styles.cardsBox}>
              {mainCards.map((card, index) => {
                return (
                  <MainCard
                    key={index}
                    content={card}
                    index={index}
                  />
                )
              })}
            </div>
          </div>
                 <ServiceSections />
                 <DesignCustomization />
                 <MainFooter />
                 </> 
                 :
                 <div className={styles.mobileContainer}>
                   <div className={styles.firstBoxMobile}>
                     <div className={styles.contentHeaderBox}>
                       <p className={styles.contentHeaderText}>
                         {t("Main.Content_1.Header")}
                       </p>
                     </div>
                     <p className={styles.contentTitle}>
                       {t("Main.Content_1.Title")}
                     </p>
                     <p className={styles.contentDescription}>
                       {t("Main.Content_1.Text")}              </p>
                     <Button
                       buttonType={ButtonTypes.Primery}
                       title={t("Main.Demo_btn")}
                       buttonStyle={styles.button}
                       onClick={() => navigate('/signUp')}
                     />
                   </div>
                   <div className={styles.cardsBoxMobile}>
                     {mainCards.map((card, index) => {
                       return (
                         <MainCard
                           key={index}
                           content={card}
                           index={index}
                         />
                       )
                     })}
                   </div>
                   <ServiceSections />
                   <DesignCustomization />
                   <MainFooter />
                 </div>
             }
           </>

         )
}

export default MainContent
